import { Settings } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Divider, Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useBikeleasingPortalLinkBuilder } from 'probonio-shared-ui/utils/bikeleasingUrl';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { HorizontalBox, VerticalBox } from '../../component/layout/BoxLayout';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasingV2/useBikeleasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

const BikeleasingSettingsPage: React.FC = () => {
  const { t } = useTranslation('extensions');
  const { PreconditionComponent, isPreconditionMet } = useBikeleasingPrecondition();
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();
  const bikeleasingEmployerProfileUrl = buildBikeleasingPortalLink(`/user/company-profile/employer`);

  return (
    <AuthorizedLayout
      title={t('bikeleasing_v2.settings.title')}
      breadcrumbs={[{ title: t('bikeleasing_v2.title'), to: `/benefits/${BenefitDTOBenefitEnum.BikeleasingV2.toLowerCase()}` }]}
    >
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.BikeleasingV2)}
        title={t('bikeleasing_v2.title')}
        subTitle={t('bikeleasing_v2.settings.title')}
      >
        <BenefitPaper>
          {isPreconditionMet ? (
            <Box sx={{ p: 1.5 }}>
              <VerticalBox>
                <HorizontalBox gap={1} alignItems="center">
                  <Settings fontSize="large" />
                  <Typography variant="h2">{t('bikeleasing_v2.settings.infoTitle')}</Typography>
                </HorizontalBox>
              </VerticalBox>
              <Divider sx={{ my: 3 }} />
              <Box>
                <Trans i18nKey="extensions:bikeleasing_v2.settings.infoText" />
                <Link
                  href={bikeleasingEmployerProfileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ ml: 0.5, flex: 1, display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
                >
                  {t('extensions:bikeleasing_v2.settings.infoAction')}
                  <OpenInNewIcon fontSize="small" />
                </Link>
              </Box>
            </Box>
          ) : (
            PreconditionComponent
          )}
        </BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default BikeleasingSettingsPage;
